<div class="list-skeleton-wrapper">
  <div class="list-sk-card" *ngFor="let i of items">

    <div class="list-sk-card__body">
      <!-- Classes: name + description + teacher -->
      <ng-container *ngIf="variant === 'classes'">
        <div class="list-sk-line sk-shimmer" style="width: 55%"></div>
        <div class="list-sk-line sk-shimmer" style="width: 38%"></div>
        <div class="list-sk-line sk-shimmer" style="width: 28%"></div>
      </ng-container>
      <!-- Users: name + email + ID -->
      <ng-container *ngIf="variant === 'users'">
        <div class="list-sk-line sk-shimmer" style="width: 45%"></div>
        <div class="list-sk-line sk-shimmer" style="width: 36%"></div>
        <div class="list-sk-line sk-shimmer" style="width: 22%"></div>
      </ng-container>
    </div>

    <div class="list-sk-card__actions">
      <div class="list-sk-btn sk-shimmer"></div>
      <div class="list-sk-btn sk-shimmer"></div>
    </div>

    <div class="list-sk-card__stats">
      <div class="list-sk-badge sk-shimmer"></div>
      <div class="list-sk-badge sk-shimmer"></div>
      <div class="list-sk-badge sk-shimmer" *ngIf="variant === 'classes'"></div>
    </div>

  </div>
</div>
